export default __webpack_public_path__ + "static/zebra-4d72b44e9a55ae411c564af6048b9923.png";